<template>
  <table class="striped admin-equipment-items-table">
    <caption v-html="caption" v-if="caption" />
    <colgroup>
      <col width="50%" />
      <col width="50%" />
    </colgroup>
    <thead>
      <tr>
        <th>Equipment Item</th>
        <th>Subcategory</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in paginatedItems"
        :key="item.id"
        :class="selectedId === item.id ? 'selected' : 'selectable'"
        @click="handleSelect(item)"
      >
        <td>{{ item.name }}</td>
        <td>{{ (item.subcategory || {}).name }}</td>
      </tr>
      <tr v-if="items.length === 0">
        <td class="no-records" colspan="2">
          There are currently no equipment items in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="2">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("items")],

  props: {
    caption: {
      item: String,
      default: undefined,
    },
    items: {
      item: Array,
    },
    selectedId: {
      item: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(item) {
      this.$emit("select", item);
    },
  },
};
</script>